/*
*###############################################################################
*Module Name                   : DesignationMaster.js                          #
*Purpose of the Module         :                                               #
*Description of the Module     :                                               #
*Original Author               : I Dinisuru Balasuriya                         #
*Date                          : Monday, August 30th 2021, 10:14:01 am         #
*Copyright © 2021 myPOS Software Solution (pvt Ltd.)                           #
*###############################################################################
*/

import DPTextBoxforgrid from 'framework/components/DPTextBoxforgrid'
import React, { useState, useEffect, useContext } from 'react'
import ReactPaginate from 'react-paginate'
import { Col, Row, Button } from 'reactstrap'
import { GetAllTxn, getCustomerDetails, getGenSearchHeader, getProductDetails, getReportData, getSupplierDetails } from './SearchDashboardController'
import moment from 'moment'
import { Link } from "react-router-dom"
import { Context } from "app-contexts/CommonContexts"
import DPSearchBoxDynamic from 'framework/components/DPSearchBoxDynamic'
import DPSwitch from 'framework/components/DPSwitch'


const SearchDashboardContent = ({ menuCode, setShow, setAlertMsg, setAlertColor, SetLoadingAlert, SetLoadingAlerttitle }) => {

    const ApiURL = window.Links.ApiURL

    const {
        txnDecimalAmt
    } = useContext(Context);


    const [customClick, setCustomClick] = useState(false)
    const [selectedColumn, setSelectedColumn] = useState(0)
    const [fromDate, setFromDate] = useState('')
    const [toDate, setToDate] = useState('')

    const [txn, setTxn] = useState([])
    const [filteredTxn, setFilteredTxn] = useState([])
    const [txnPage, setTxnPage] = useState(1)
    const [txnSearch, setTxnSearch] = useState('')

    const [headPage, setHeadPage] = useState(1)

    const [detailPage, setDetailPage] = useState(1)



    const [supplier, setSupplier] = useState("")
    const [customer, setCustomer] = useState("")
    const [product, setProduct] = useState("")
    const [documentNo, setDocumentNo] = useState("")
    const [comment, setComment] = useState("")
    const [transactionType, setTransactionType] = useState("")
    const [processed, setProcessed] = useState(true)
    const [isTransaction, setIsTransaction] = useState(true)
    const [isInvoice, setIsInvoice] = useState(false)


    const [cardPage, setCardPage] = useState(0)

    const [headerDetails, setHeaderDetails] = useState([])
    const [detailData, setDetailData] = useState([])
    const [searchValue, setSearchValue] = useState('')
    const [searchParam, setSearchParam] = useState('document')



    const [supSearchToggle, setSupSearchToggle] = useState(false)
    const [prodSearchToggle, setProdSearchToggle] = useState(false)
    const [custSearchToggle, setCustSearchToggle] = useState(false)



    function supSearchOnClickHandle() {
        setSupSearchToggle(!supSearchToggle)
    }

    function prodSearchOnClickHandle() {
        setProdSearchToggle(!prodSearchToggle)
    }

    function custSearchOnClickHandle() {
        setCustSearchToggle(!custSearchToggle)
    }


    function supSearchRowClickHandle(e, row) {
        setSupplier(row.SM_CODE)
        supSearchOnClickHandle()
    }

    function prodSearchRowClickHandle(e, row) {
        setProduct(row.PLU_CODE)
        prodSearchOnClickHandle()
    }

    function custSearchRowClickHandle(e, row) {
        setCustomer(row.CM_CODE)
        custSearchOnClickHandle()
    }





    useEffect(async () => {
        var txnData = await GetAllTxn()
        if (txnData.isSuccess) {
            setTxn(txnData.data)
            setFilteredTxn(txnData.data)
        }
    }, [])

    const handleTxnPageClick = (event) => {
        setTxnPage(event.selected + 1);
    };

    const handleHeadPageClick = (event) => {
        setHeadPage(event.selected + 1);
    };

    const handleDetailPageClick = (event) => {
        setDetailPage(event.selected + 1);
    };

    const txnFilterData = filteredTxn.filter((item) => {
        if (txnSearch == null)
            return item
        else if (item.description.toLowerCase().includes(txnSearch.toLowerCase())) {
            return item
        }
    })

    const indexOfLastPostTxn = txnPage * 10
    const indexOfFirstPostTxn = indexOfLastPostTxn - 10
    const currentDetailRowsTxn = txnFilterData.slice(indexOfFirstPostTxn, indexOfLastPostTxn)


    const filteredHeaderDetails = headerDetails.filter((item) => {
        if (searchValue == null || searchValue == '')
            return item
        else if (item[searchParam].toLowerCase().includes(searchValue.toLowerCase())) {
            return item
        }
    })



    const indexOfLastPostHead = headPage * 10
    const indexOfFirstPostHead = indexOfLastPostHead - 10
    const currentDetailRowsHead = filteredHeaderDetails.slice(indexOfFirstPostHead, indexOfLastPostHead)


    function txnOnClickHandle(txnType) {
        const newTxn = filteredTxn.map(item => ({
            ...item,
            isChecked: item.type == txnType
        }));
        setFilteredTxn(newTxn);
    }

    function filterTxnOnCardClick(element) {
        setTxnPage(1)
        var filteredTxn = []
        switch (element) {
            case 'Purchasing':
                filteredTxn = txn.filter((item) => {
                    if (item.saveInvoice == 0)
                        return item
                })

                setFilteredTxn(filteredTxn)
                break;
            case 'Sales':
                filteredTxn = txn.filter((item) => {
                    if (item.saveInvoice == 1)
                        return item
                }
                )
                setFilteredTxn(filteredTxn)
                break;
            case 'Inventory':
                filteredTxn = txn.filter((item) => {
                    if (item.binEntry == 1)
                        return item
                }
                )
                setFilteredTxn(filteredTxn)
                break;
            default:
                setFilteredTxn(txn)
                break;
        }
    }



    async function handleGenSearch() {
        setHeadPage(1)

        if (fromDate.length == 0 || toDate.length == 0) {
            setAlertMsg("Please select from date and to date")
            setAlertColor("danger")
            setShow(true)
            setTimeout(() => {
                setShow(false)
            }, 5000);
            return
        }

        var data = {

            fromDate: fromDate,
            toDate: toDate,
            supplier: supplier,
            customer: customer,
            product: product,
            document: documentNo,
            txnType: transactionType,
            comment: comment,
            isProcessed: processed,
            isTransaction: isTransaction,
            isInvoice: isInvoice

        }

        try {
            SetLoadingAlert(true)
            SetLoadingAlerttitle("Getting data...")

            var result = await getGenSearchHeader(data)
            SetLoadingAlert(false)
            if (result.isSuccess) {
                setHeaderDetails(result.data)
            } else {

                setAlertMsg("No data found")
                setAlertColor("danger")
                setShow(true)
                setTimeout(() => {
                    setShow(false)
                }, 5000);

                setHeaderDetails([])
            }
        } catch (e) {
            SetLoadingAlert(false)
            console.log(e)
        }

    }


    function resetAllElements() {
        setFromDate('')
        setToDate('')
        setSupplier('')
        setCustomer('')
        setProduct('')
        setDocumentNo('')
        setComment('')
        setHeaderDetails([])
        setDetailData([])
        setSelectedColumn(0)
        setCardPage(0)
        txnOnClickHandle('')
        filterTxnOnCardClick('')
        setTransactionType('')
        setProcessed(true)
        setIsTransaction(true)
        setIsInvoice(false)
        setTxnSearch("")
        setSearchParam('document')
        setSearchValue('')
    }


    const defaultSorted = [{
        dataField: 'id',
        order: 'asc'
    }];



    return (
        <React.Fragment>

            <Row>
                <Col className='p-1' lg={2}>
                    <div className={`card bg-${cardPage == 1 ? 'primary' : 'secondary'} text-white shadow-lg `} onClick={() => {
                        filterTxnOnCardClick('Purchasing')
                        setCardPage(1)
                    }} style={{ cursor: 'pointer' }}>
                        <div className="card-body">
                            <i className="mdi mdi-chess-rook me-3 tex" /> Purchasing
                            <p className="card-text">All Purchasing related transactions.</p>
                        </div>
                    </div>
                </Col>

                <Col className='p-1' lg={2}>
                    <div className={`card bg-${cardPage == 2 ? 'success' : 'secondary'} text-white shadow-lg `} onClick={() => {
                        filterTxnOnCardClick('Sales')
                        setCardPage(2)
                    }} style={{ cursor: 'pointer' }}>
                        <div className="card-body">
                            <i className="mdi mdi-point-of-sale me-3" /> Sales
                            <p className="card-text">All Sales related transactions. &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</p>
                        </div>
                    </div>
                </Col>

                <Col className='p-1' lg={2}>
                    <div className={`card bg-${cardPage == 3 ? 'warning' : 'secondary'} text-white shadow-lg `} onClick={() => {
                        filterTxnOnCardClick('Inventory')
                        setCardPage(3)
                    }} style={{ cursor: 'pointer' }}>
                        <div className="card-body">
                            <i className="mdi mdi-cart-minus me-3" />Inventory
                            <p className="card-text">All stock related transactions. &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</p>
                        </div>
                    </div>
                </Col>
                <Col className='p-1' lg={2}>
                    <div className={`card bg-${cardPage == 4 ? 'info' : 'secondary'} text-white shadow-lg `} onClick={() => {
                        filterTxnOnCardClick('All')
                        setCardPage(4)
                    }} style={{ cursor: 'pointer' }}>
                        <div className="card-body">
                            <i className="mdi mdi-creative-commons me-3" />Common
                            <p className="card-text">All Transactions.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</p>
                        </div>
                    </div>
                </Col>

                <Col className='p-1' lg={4}>
                    <table className="table  table-striped table-sm " >
                        <thead>
                            <tr>
                                <th className=' border border-primary' style={{ background: selectedColumn == 1 ? '#B4B8BD' : '#EFF2F7', textAlign: 'center', width: '100px', cursor: 'pointer' }} onClick={() => {
                                    setSelectedColumn(1)
                                    setCustomClick(false)
                                    var date = new Date();
                                    //get last year
                                    var lastYearBegin = new Date(date.getFullYear() - 1, 0, 1);
                                    var lastYearEnd = new Date(date.getFullYear() - 1, 11, 31);

                                    setFromDate(moment(lastYearBegin).format('YYYY-MM-DD'))
                                    setToDate(moment(lastYearEnd).format('YYYY-MM-DD'))

                                }}>Last Year</th>
                                <th className=' border border-primary' style={{ background: selectedColumn == 2 ? '#B4B8BD' : '#EFF2F7', textAlign: 'center', cursor: 'pointer' }} onClick={() => {
                                    setSelectedColumn(2)
                                    setCustomClick(false)
                                    var date = new Date();
                                    //get last month
                                    var lastMonthBegin = new Date(date.getFullYear(), date.getMonth() - 1, 1);
                                    var lastMonthEnd = new Date(date.getFullYear(), date.getMonth(), 0);

                                    setFromDate(moment(lastMonthBegin).format('YYYY-MM-DD'))
                                    setToDate(moment(lastMonthEnd).format('YYYY-MM-DD'))


                                }}>Last Month</th>
                                <th className=' border border-primary' style={{ background: selectedColumn == 3 ? '#B4B8BD' : '#EFF2F7', textAlign: 'center', textAlign: 'center', cursor: 'pointer' }} onClick={() => {
                                    setSelectedColumn(3)
                                    setCustomClick(false)

                                    var date = new Date();
                                    //get last week

                                    var lastWeekBegin = new Date(date.getFullYear(), date.getMonth(), date.getDate() - 7);
                                    var lastWeekEnd = new Date(date.getFullYear(), date.getMonth(), date.getDate() - 1);

                                    setFromDate(moment(lastWeekBegin).format('YYYY-MM-DD'))
                                    setToDate(moment(lastWeekEnd).format('YYYY-MM-DD'))
                                }}>Last Week</th>
                                <th className=' border border-primary' style={{ background: selectedColumn == 4 ? '#B4B8BD' : '#EFF2F7', textAlign: 'center', cursor: 'pointer', verticalAlign: 'middle' }} rowSpan={2} onClick={(e) => {
                                    setSelectedColumn(4)
                                    setCustomClick(true)
                                    setFromDate('')
                                    setToDate('')
                                }}>Custom</th>
                            </tr>
                            <tr>
                                <th className='border border-primary' style={{ background: selectedColumn == 5 ? '#B4B8BD' : '#EFF2F7', textAlign: 'center', cursor: 'pointer' }} onClick={() => {
                                    setSelectedColumn(5)
                                    setCustomClick(false)

                                    var date = new Date();
                                    //this year

                                    var thisYearBegin = new Date(date.getFullYear(), 0, 1);
                                    var currentDate = new Date(date.getFullYear(), date.getMonth(), date.getDate());

                                    setFromDate(moment(thisYearBegin).format('YYYY-MM-DD'))
                                    setToDate(moment(currentDate).format('YYYY-MM-DD'))


                                }}>Current Year</th>
                                <th className='border border-primary' style={{ background: selectedColumn == 6 ? '#B4B8BD' : '#EFF2F7', textAlign: 'center', cursor: 'pointer' }} onClick={() => {
                                    setSelectedColumn(6)
                                    setCustomClick(false)

                                    var date = new Date();
                                    //this month

                                    var thisMonthBegin = new Date(date.getFullYear(), date.getMonth(), 1);
                                    var currentDate = new Date(date.getFullYear(), date.getMonth(), date.getDate());

                                    setFromDate(moment(thisMonthBegin).format('YYYY-MM-DD'))
                                    setToDate(moment(currentDate).format('YYYY-MM-DD'))

                                }}>Current Month</th>
                                <th className='border border-primary' style={{ background: selectedColumn == 7 ? '#B4B8BD' : '#EFF2F7', textAlign: 'center', cursor: 'pointer' }} onClick={() => {
                                    setSelectedColumn(7)
                                    setCustomClick(false)

                                    var date = new Date();
                                    //this week

                                    var thisWeekBegin = new Date(date.getFullYear(), date.getMonth(), date.getDate() - date.getDay() + 1);
                                    var currentDate = new Date(date.getFullYear(), date.getMonth(), date.getDate());

                                    setFromDate(moment(thisWeekBegin).format('YYYY-MM-DD'))
                                    setToDate(moment(currentDate).format('YYYY-MM-DD'))

                                }}>Current Week</th>
                            </tr>
                            {customClick ? <tr>
                                <th className='border border-primary' style={{ background: '#EFF2F7', textAlign: 'center', verticalAlign: 'middle' }}>From Date</th>
                                <th className='border border-primary ' colSpan={3} style={{ background: '#EFF2F7', textAlign: 'center' }}>
                                    <Row>
                                        <Col className='pl-2' lg={6}>
                                            <input type="date" className="form-control-sm border-1 border-dark"
                                                value={fromDate}
                                                onChange={(e) => {
                                                    setFromDate(e.target.value)
                                                }}
                                            />
                                        </Col>
                                        <Col className='pr-2' lg={6}>
                                            <input type="date" className="form-control-sm border-1 border-dark"
                                                value={toDate}
                                                onChange={(e) => {
                                                    setToDate(e.target.value)
                                                }}
                                            />
                                        </Col>
                                    </Row>

                                </th>
                            </tr > : null}
                        </thead >
                    </table >
                </Col >

            </Row >
            <Row>
                <Col className='p-1' lg={2}>
                    <table className="custom-table table-bordered table-sm rounded">
                        <thead className='table-secondary'>
                            <tr>
                                <th>
                                    <DPTextBoxforgrid
                                        placeholder={"Transaction Search..."}
                                        value={txnSearch}
                                        onChange={(e) => {
                                            setTxnSearch(e.target.value)
                                        }}
                                    /></th>
                            </tr>
                        </thead>
                        <tbody>
                            {currentDetailRowsTxn.map((item, index) => (
                                <tr key={index} onClick={() => {
                                    txnOnClickHandle(item.type)
                                    setTransactionType(item.type)
                                }}
                                    style={{ background: item.isChecked ? '#B4B8BD' : '' }}
                                >
                                    <td>{item.description}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    <ReactPaginate
                        previousLabel={'Previous'}
                        nextLabel={'Next'}
                        breakLabel={'...'}
                        pageClassName="page-item"
                        pageLinkClassName="page-link"
                        previousClassName="page-item"
                        previousLinkClassName="page-link"
                        nextClassName="page-item"
                        nextLinkClassName="page-link"
                        breakClassName="page-item"
                        breakLinkClassName="page-link"
                        pageCount={Math.ceil(txnFilterData.length / 10)}
                        pageRangeDisplayed={2}
                        onPageChange={handleTxnPageClick}
                        forcePage={txnPage - 1}
                        renderOnZeroPageCount={null}
                        activeClassName={'active'}
                        activeLinkClassName={'page-link'}
                        containerClassName={'pagination justify-content-end pagination-sm'}

                    />
                </Col>
                <Col className='p-1' lg={10}>
                    <Row>
                        <Col className='mx-1' lg={12}>
                            <table className="custom-table table-bordered table-sm rounded table-no-border table-no-hover">

                                <tbody>
                                    <tr>
                                        <td className='col-2 '>Supplier</td>
                                        <td className='col-3'>
                                            <DPTextBoxforgrid
                                                value={supplier}
                                                onChange={(e) => {
                                                    setSupplier(e.target.value)
                                                }}
                                                onBlur={async (e) => {
                                                    var supData = await getSupplierDetails(e.target.value)
                                                    if (supData.isSuccess == false) {
                                                        setSupplier('')
                                                    }
                                                }}
                                            />
                                        </td>
                                        <td className='col-1'>
                                            <Button
                                                outline
                                                color="success"
                                                size="sm"
                                                onClick={() => {
                                                    supSearchOnClickHandle()
                                                }}
                                            >
                                                <i
                                                    className="mdi mdi-search-web"
                                                    style={{ fontSize: "12px" }}
                                                ></i>
                                            </Button>
                                        </td>
                                        <td className='col-2 '>Customer</td>
                                        <td className='col-3'>
                                            <DPTextBoxforgrid
                                                value={customer}
                                                onChange={(e) => {
                                                    setCustomer(e.target.value)
                                                }}
                                                onBlur={async (e) => {
                                                    var cusData = await getCustomerDetails(e.target.value)
                                                    if (cusData.isSuccess == false) {
                                                        setCustomer('')
                                                    }
                                                }}
                                            />
                                        </td>
                                        <td className='col-1'>
                                            <Button
                                                outline
                                                color="success"
                                                size="sm"
                                                onClick={() => {
                                                    custSearchOnClickHandle()
                                                }}
                                            >
                                                <i
                                                    className="mdi mdi-search-web"
                                                    style={{ fontSize: "12px" }}
                                                ></i>
                                            </Button>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className='col-2 '>Product</td>
                                        <td className='col-3'>
                                            <DPTextBoxforgrid
                                                value={product}
                                                onChange={(e) => {
                                                    setProduct(e.target.value)
                                                }}
                                                onBlur={async (e) => {
                                                    var proData = await getProductDetails(e.target.value)
                                                    if (proData.isSuccess == false || proData.data == "") {
                                                        setProduct('')
                                                    }
                                                }}
                                            />
                                        </td>
                                        <td className='col-1'>
                                            <Button
                                                outline
                                                color="success"
                                                size="sm"
                                                onClick={() => {
                                                    prodSearchOnClickHandle()
                                                }}
                                            >
                                                <i
                                                    className="mdi mdi-search-web"
                                                    style={{ fontSize: "12px" }}
                                                ></i>
                                            </Button>
                                        </td>
                                        <td className='col-2 '>Document No</td>
                                        <td className='col-3'>
                                            <DPTextBoxforgrid
                                                value={documentNo}
                                                onChange={(e) => {
                                                    setDocumentNo(e.target.value)
                                                }}
                                            />
                                        </td>
                                        {/* <td className='col-1'>
                                            <Button
                                                outline
                                                color="success"
                                                size="sm"
                                            >
                                                <i
                                                    className="mdi mdi-search-web"
                                                    style={{ fontSize: "12px" }}
                                                ></i>
                                            </Button>
                                        </td> */}
                                    </tr>
                                    <tr>
                                        <td className='col-2 '>Comments</td>
                                        <td className='col-3'>
                                            <DPTextBoxforgrid
                                                value={comment}
                                                onChange={(e) => {
                                                    setComment(e.target.value)
                                                }}
                                            />
                                        </td>
                                        <td col className='col-1'></td>
                                        <td colSpan={2}>
                                            <Row>
                                                <Col className='col-6'>
                                                    <Button
                                                        outline
                                                        color="success"
                                                        style={{ width: '100%' }}
                                                        size="sm"
                                                        onClick={() => {
                                                            handleGenSearch()
                                                        }}
                                                    >
                                                        Search
                                                    </Button>
                                                </Col>
                                                <Col className='col-6'>
                                                    <Button
                                                        outline
                                                        color="primary"
                                                        style={{ width: '100%' }}
                                                        size="sm"
                                                        onClick={() => {
                                                            resetAllElements()
                                                        }}
                                                    >
                                                        Reset All
                                                    </Button>
                                                </Col>
                                            </Row>

                                        </td>
                                    </tr>
                                    <tr>
                                        <td colSpan={4} className='col-2 '>
                                            <Row>
                                                <Col className='col-2'>
                                                    Processed
                                                </Col>
                                                <Col className='col-2'>
                                                    <DPSwitch
                                                        checked={processed}
                                                        onChange={(e) => {
                                                            setProcessed(e)
                                                        }}
                                                    />
                                                </Col>
                                                <Col className='col-2'>
                                                    Transaction
                                                </Col>
                                                <Col className='col-2'>
                                                    <DPSwitch
                                                        checked={isTransaction}
                                                        onChange={(e) => {
                                                            setIsTransaction(e)
                                                        }}
                                                    />
                                                </Col>
                                                <Col className='col-2'>
                                                    Inv Related
                                                </Col>
                                                <Col className='col-2'>
                                                    <DPSwitch
                                                        checked={isInvoice}
                                                        onChange={(e) => {
                                                            setIsInvoice(e)
                                                        }}
                                                    />
                                                </Col>
                                            </Row>
                                        </td>

                                    </tr>

                                </tbody>
                            </table>
                        </Col>
                    </Row>
                    <Row>
                        <Col className='mx-1' lg={12}>
                            {headerDetails.length > 0 ? <input type='text'
                                id='search'
                                className='form-control form-control-sm mw-10'
                                placeholder='Search...'
                                value={searchValue}
                                onChange={(e) => {
                                    setSearchValue(e.target.value)
                                    setHeadPage(1)
                                }}
                                style={{ marginBottom: '10px' }} /> : null}
                            {headerDetails.length > 0 ?


                                <table className="custom-table table-bordered table-sm rounded">
                                    <thead className='table-secondary'>
                                        <tr>
                                            <th onClick={() => {
                                                setSearchValue('')
                                                setSearchParam('date')
                                            }} style={{ cursor: "pointer" }}>Date</th>
                                            <th onClick={() => {
                                                setSearchValue('')
                                                setSearchParam('transaction')
                                            }} style={{ cursor: "pointer" }}>Transaction</th>
                                            <th onClick={() => {
                                                setSearchValue('')
                                                setSearchParam('document')
                                            }} style={{ cursor: "pointer" }}>Document</th>
                                            <th onClick={() => {
                                                setSearchValue('')
                                                setSearchParam('location')
                                            }} style={{ cursor: "pointer" }}>From_Location</th>
                                            <th onClick={() => {
                                                setSearchValue('')
                                                setSearchParam('tolocation')
                                            }} style={{ cursor: "pointer" }}>To_Location</th>
                                            <th>Supplier/Customer</th>
                                            <th style={{ textAlign: 'end' }}>QTY</th>
                                            <th style={{ textAlign: 'end' }}>Disc %</th>
                                            <th style={{ textAlign: 'end' }}>Disc Amt</th>
                                            <th style={{ textAlign: 'end' }}>Net Amt</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {currentDetailRowsHead.map((item, index) => {
                                            var redirectUrl = ''
                                            if (item.supCode) {
                                                redirectUrl = `/VendorMaster?${item.supCode}`
                                            }

                                            if (item.cusCode) {
                                                redirectUrl = `/CustomerMaster?${item.cusCode}`
                                            }
                                            return (
                                                <tr key={index}>
                                                    <td style={{ width: '95px' }}>{item.date.slice(0, 10)}</td>
                                                    <td title={item.transaction}>{item.transaction}</td>
                                                    {item.type != "INV" ? <td><Link to={`/Transaction?${item.type}&${item.document}`} target="_blank" >{item.document}</Link></td> : <td>{item.document}</td>}
                                                    <td>{item.location}</td>
                                                    <td>{item.tolocation}</td>
                                                    <td><Link to={redirectUrl} target="_blank" >{item.supCode ? `(${item.supCode}) ${item.supplier}` : item.cusCode ? `(${item.cusCode}) ${item.customer}` : ""} </Link></td>
                                                    <td style={{ width: '60px', textAlign: 'end' }}>{parseFloat(item.proCount)}</td>
                                                    <td style={{ width: '60px', textAlign: 'end' }}>{parseFloat(item.discount).toFixed(txnDecimalAmt)}</td>
                                                    <td style={{ width: '80px', textAlign: 'end' }}>{parseFloat(item.discountAmount).toFixed(txnDecimalAmt)}</td>
                                                    <td style={{ width: '100px', textAlign: 'end' }}>{parseFloat(item.netAnount).toFixed(txnDecimalAmt)}</td>
                                                </tr>
                                            )
                                        })}
                                    </tbody>
                                </table> : null}

                            <ReactPaginate
                                previousLabel={'Previous'}
                                nextLabel={'Next'}
                                breakLabel={'...'}
                                pageClassName="page-item"
                                pageLinkClassName="page-link"
                                previousClassName="page-item"
                                previousLinkClassName="page-link"
                                nextClassName="page-item"
                                nextLinkClassName="page-link"
                                breakClassName="page-item"
                                breakLinkClassName="page-link"
                                pageCount={Math.ceil(filteredHeaderDetails.length / 10)}
                                pageRangeDisplayed={2}
                                onPageChange={handleHeadPageClick}
                                forcePage={headPage - 1}
                                renderOnZeroPageCount={null}
                                activeClassName={'active'}
                                activeLinkClassName={'page-link'}
                                containerClassName={'pagination justify-content-end pagination-sm'}

                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col className='mx-1' lg={12}>
                            {detailData.length > 0 ? <table className="table table-bordered  table-sm">
                                <thead className='table-secondary'>
                                    <tr>
                                        <th>Pro Code</th>
                                        <th>Pro Name</th>
                                        <th>Cost</th>
                                        <th>Selling</th>
                                        <th>Case Size</th>
                                        <th>Case Qty</th>
                                        <th>Free Case Qty</th>
                                        <th>Unit Qty</th>
                                        <th>Free Unit Qty</th>
                                        <th>Disc %</th>
                                        <th>Disc Amt</th>
                                        <th>Net Amt</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {detailData.map((item, index) => {
                                        return (
                                            <tr key={index}>
                                                <td>{item.productCode}</td>
                                                <td>{item.productName}</td>
                                                <td>{item.cost}</td>
                                                <td>{item.selling}</td>
                                                <td>{item.caseSize}</td>
                                                <td>{item.caseQty}</td>
                                                <td>{item.freeCaseQty}</td>
                                                <td>{item.unitQty}</td>
                                                <td>{item.freeUnitQty}</td>
                                                <td>{item.discount}</td>
                                                <td>{item.discountAmount}</td>
                                                <td>{item.netAnount}</td>
                                            </tr>
                                        )
                                    })}
                                </tbody>
                            </table> : null}

                            <ReactPaginate
                                previousLabel={'Previous'}
                                nextLabel={'Next'}
                                breakLabel={'...'}
                                pageClassName="page-item"
                                pageLinkClassName="page-link"
                                previousClassName="page-item"
                                previousLinkClassName="page-link"
                                nextClassName="page-item"
                                nextLinkClassName="page-link"
                                breakClassName="page-item"
                                breakLinkClassName="page-link"
                                pageCount={Math.ceil(detailData.length / 10)}
                                pageRangeDisplayed={2}
                                onPageChange={handleDetailPageClick}
                                forcePage={detailPage - 1}
                                renderOnZeroPageCount={null}
                                activeClassName={'active'}
                                activeLinkClassName={'page-link'}
                                containerClassName={'pagination justify-content-end pagination-sm'}

                            />

                        </Col>
                    </Row>
                </Col>


                <DPSearchBoxDynamic
                    searchData={[]}
                    columns={[]}
                    defaultSorted={defaultSorted}
                    mainTitle={"Supplier Search"}
                    SelectType={"checkbox"} //checkbox for multipe, radio for single, ROW_SELECT_DISABLED for disable
                    isOpen={supSearchToggle}
                    toggle={supSearchOnClickHandle}
                    getSelect={supSearchRowClickHandle}
                    APIURL={ApiURL}
                    URLPath={"SUPPLIER"}
                    MenuCode={menuCode}
                    KeyVal={"SUP"}
                    searchBy={"SM_CODE"}
                    FilterStr={"a"}
                />


                <DPSearchBoxDynamic
                    searchData={[]}
                    columns={[]}
                    defaultSorted={defaultSorted}
                    mainTitle={"Customer Search"}
                    SelectType={"checkbox"} //checkbox for multipe, radio for single, ROW_SELECT_DISABLED for disable
                    isOpen={custSearchToggle}
                    toggle={custSearchOnClickHandle}
                    getSelect={custSearchRowClickHandle}
                    APIURL={ApiURL}
                    URLPath={"CUSTOMER"}
                    MenuCode={menuCode}
                    KeyVal={"CUS"}
                    searchBy={"CM_CODE"}
                    FilterStr={"a"}
                />


                <DPSearchBoxDynamic
                    searchData={[]}
                    columns={[]}
                    defaultSorted={defaultSorted}
                    mainTitle={"Product Search"}
                    SelectType={"checkbox"} //checkbox for multipe, radio for single, ROW_SELECT_DISABLED for disable
                    isOpen={prodSearchToggle}
                    toggle={prodSearchOnClickHandle}
                    getSelect={prodSearchRowClickHandle}
                    APIURL={ApiURL}
                    URLPath={"PRODUCT"}
                    MenuCode={menuCode}
                    KeyVal={"PRO"}
                    searchBy={"PLU_CODE"}
                    FilterStr={"a"}
                />
            </Row>
        </React.Fragment >
    )

}

export default SearchDashboardContent